import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TextField,
  Grid,
  CardHeader,
  Divider,
  Button,
  Fab,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio, CircularProgress
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SaveIcon from "@material-ui/icons/Save";
import RTL from "../../../../components/RTL";
import Company from "./../../../Company";
import Autocomplete from "@material-ui/lab/Autocomplete";
import clsx from "clsx";

import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useDispatch, useSelector } from "react-redux";
import { Loading, showSnackbar } from "redux/Action";
import {axios} from "./../../../../axios";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: "100%",
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  imageInput: {
    display: "none",
  },
  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width:'100%'
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));

const Form = (props) => {
  const { data, id, edit,onClose,reloadFunc } = props;

  const classes = useStyles();
  const [Companys, SetCompanys] = useState([]);

  const [Roles, setRoles] = React.useState([]);

  var
  persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
  arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
  fixNumbers = function (str)
  {
    if(typeof str === 'string')
    {
      for(var i=0; i<10; i++)
      {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      } 
    }
    return str;
  };



  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector(state=>state.isLoading);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [error, setError] = React.useState({
    full_name:"",
    cell:"",
    company_id:"",
    role_id:null
  });
  const [value, setValue] = React.useState({
    full_name:"",
    cell:"",
    company_id:"",
    role_id:null

  });
  
  const [CompanySel, SetCompanySel] = useState('');
  const [RoleSel, setRoleSel] = useState('');


  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };


  const Get_Data_Sel = async () => {
    try{
      const res = await axios.get(`staff/${id}`, {
        headers: headers,
      });
    setValue({ ...value, 
    full_name:res.data.staff?.user?.full_name,
    cell:res.data.staff?.user?.cell,
    company_id:res.data.staff?.company?.id,
    role_id:res.data.staff?.user?.roles['0']?.id

    });
    setRoleSel( res.data.staff?.user?.roles['0']?.alias_title)
   
    SetCompanySel(res.data.staff?.company?.name)

     dispatch(Loading());
    }catch(e)
    {
      dispatch(Loading());      
    }
}




  const Get_Component = async () => {
  
    try{
      const resRole = await axios.get('roles/can-create-shipment', {
        headers: headers,
      });
      setRoles(resRole.data.roles);

      const res = await axios.get('staff/create', {
        headers: headers,
      });
      SetCompanys(res.data.companies)
     
      if(edit)
      {
        Get_Data_Sel();
        dispatch(Loading());

      }
     
        
    //  console.log(res.data.companies,"axx")
       dispatch(Loading())

    }catch(e)
    {
      dispatch(Loading())
      // console.log(e.response,"eeeeeeeee")
      
    }
  
  
}



  useEffect(() => {
    Get_Component();
    dispatch(Loading());

  }, []);

 

  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;

    let name =e.target.name;
    setError({ ...error, [name]: "" });

    switch (name) {
      case "cell":
        if (fixNumbers(e.target.value ) === "" || re.test(fixNumbers(e.target.value))) {
          if (e.target.value.length < 12) {
            setValue({ ...value, [name]: fixNumbers(e.target.value) });
            setError({ ...error, [name]: "" });
          }
        } else {
          setError({ ...error, [name]: "شماره تماس فقط بصورت عدد می باشد" });
        }
        break;

     
      
      default:
        setValue({ ...value, [name]: e.target.value });

        break;
    }

  };


  const InsertEmployee = async () => {
  
    try{
      const res = await axios.post('staff', {
        full_name:value.full_name,
        company_id:value.company_id,
        cell:value.cell,
        role_id:value.role_id
      },{
        headers:headers
      });
      dispatch(showSnackbar(true,'success','کارمند با موفقیت ثبت شد'))
      setValue({...value,
        company_id:"",
      full_name:"",
      role_id:null,
      cell:""
      })
      SetCompanySel("");
      setRoleSel("");
       dispatch(Loading())

    }catch(e)
    {
      dispatch(Loading())
      // console.log(e.response,"eeeeeeeee")
      if (e.response.status === 422)
      {
        const er = e.response.data.errors;
        
        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {
        
          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }
  
  
}




const UpdateEmployee = async () => {
  
  try{
    const res = await axios.post(`staff/${id}`, {
      full_name:value.full_name,
        company_id:value.company_id,
        cell:value.cell,
        role_id:value.role_id,
      _method:'patch'
    },{
      headers:headers
    });
    dispatch(showSnackbar(true,'success','کارمند با موفقیت بروزرسانی شد'))
    setValue({...value,
      full_name:"",
      company_id:"",
      cell:"",
      role_id:null
    })
    SetCompanySel("");
    setRoleSel("");
    reloadFunc();
    onClose()
     dispatch(Loading())

  }catch(e)
  {
    dispatch(Loading())
    // console.log(e.response,"eeeeeeeee")
    if (e.response.status === 422)
    {
      const er = e.response.data.errors;
      
      let er_keys = Object.keys(er);
      let obj_error = {};
      er_keys.forEach((element) => {
      
        obj_error[element] = er[element][0];
      });

      setError(obj_error);
    }
  }


}

    
  const sendBtn = () => {
    let va_keys = Object.keys(value);

    let obj_empty = {};
    va_keys.forEach((element) => {
      if(element=='cell')
      { 
        if (value[element] === "") {
          obj_empty[element] = "این فیلد نمی تواند خالی باشد";
        }
        else if(value.cell.length!=11)
        {
          obj_empty[element] = "تعداد ارقام شماره تماس صحیح نمی باشد";

        }
      } 
      
       else if (value[element] === "") {
          obj_empty[element] = "این فیلد نمی تواند خالی باشد";
        }

      
     
    });
    

    setError(obj_empty);

    if (Object.keys(obj_empty).length == 0) {
      if (edit) {
        dispatch(Loading());
        UpdateEmployee()
      } else {
        dispatch(Loading());
       InsertEmployee()
      }
    }
    else
    {
      // alert(JSON.stringify(obj_empty))
    }
  };

  return (
    <RTL>
          {!isLoading ?
     <>
      {
        edit?<Grid justify="center" container>
        <CardHeader title="ویرایش کارمند " />
        <Divider className={classes.divider} variant="fullWidth" />
      </Grid>:<Grid justify="center" container>
        <CardHeader title="ثبت کارمند جدید" />
        <Divider className={classes.divider} variant="fullWidth" />
      </Grid>
      }
      

      <Grid container justify="space-between">
       
          <Grid item xs={12} sm={5}>
          <TextField
            className={classes.input}
            label="نام و نام خانوادگی"
            variant="outlined"
            value={value.full_name}
            error={Boolean(error?.full_name)}
            helperText={(error?.full_name)}             
            onChange={handleChange}
            name="full_name"
            
          />
          
        </Grid>
        <Grid alignItems="flex-start" item xs={12} sm={6}>
        <TextField
            className={classes.input}
            label="شماره تماس"
            variant="outlined"
            value={value.cell}
            error={Boolean(error?.cell)}
            helperText={(error?.cell)}             
            onChange={handleChange}
            name="cell"
          />
        </Grid>
        </Grid>

     

      <Grid container justify="space-between">
        <Grid item xs={12} sm={5}>
        <Autocomplete
                id="NameCo"
                noOptionsText="هیچ شرکتی وجود ندارد"
                options={Companys}
                getOptionLabel={(option) => option.name}
                onChange={(event, val) =>
                  val !== null
                    ? ` ${setValue({...value,company_id:val.id})} ${SetCompanySel(val.name)} ${setError({ ...error, company_id: "" }) }`
                    : ""
                }
               

                value={{
                  name: ` ${
                      CompanySel
                  }`
                }}
               

                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="شرکت باربری "
                    variant="outlined"
                    error={Boolean(error?.company_id)}
                    helperText={(error?.company_id)} 
                  />
                )}
              />
        </Grid>

        <Grid item xs={12} sm={6}>
          
        <Autocomplete
                            noOptionsText="همچنین شغلی وجود ندارد"
                            options={Roles}
                            style={{ width: '100%' }}
                            getOptionLabel={(option) => option.alias_title || ''}
                            onChange={(e, v) =>
                              v != null ? 
                              ` ${setValue({...value,role_id:v.id})} ${setRoleSel(v.alias_title)} ${setError({ ...error, role_id: "" }) }`
                               : ` ${setValue({...value,role_id:null})} ${setRoleSel("")} ${setError({ ...error, role_id: "" }) }`

                            } 

                            
                value={{
                  alias_title: ` ${
                      RoleSel
                  }`
                }}
                            renderInput={(params) => (
                              <TextField
                                className={classes.input}
                                {...params}
                                label="عنوان شغل"
                                variant="outlined"
                                error={Boolean(error?.role_id)}
                                helperText={(error?.role_id)} 
                              />
                            )}
                          />
        </Grid>

      </Grid>

     

    
      
      {edit ? (
        <Button
          fullWidth
          className={(classes.input, classes.inputBtn)}
          variant="contained"
          color="secondary"
          onClick={()=>sendBtn()}
          size="large"
          startIcon={<SaveIcon className={classes.submitButtonIcon} />}
        >
          بروزرسانی کارمند
        </Button>
      ) : (
        <div className={classes.wrapper}>
        <Button
          fullWidth
          className={(classes.input, classes.inputBtn)}
          variant="contained"
          color="secondary"
          size="large"
          onClick={()=>sendBtn()}

          disabled={isLoading}
          startIcon={<SaveIcon className={classes.submitButtonIcon} />}
        >
          ثبت کارمند جدید
        </Button>
            {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
      )}

</>  
            :
            <div className={classes.wrapper} style={{padding:40}}>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
               </div>
            } 
    </RTL>
  );
};

export default Form;
